import { useContext } from "react"
import {
  LearnerAuthContext,
  type LearnerAuthContextValue,
} from "./LearnerAuthContext"

const useLearnerAuth = (): LearnerAuthContextValue => {
  const context = useContext(LearnerAuthContext)
  if (!context) {
    throw new Error("useLearnerAuth must be used within LearnerAuthProvider")
  }
  return context
}

export default useLearnerAuth
